<template>
  <PageContainer title="Monitorar Aulas Virtuais">
    <div v-if="!loaded" class="d-flex justify-content-center">
      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
      </component>
    </div>

    <template v-else>
      <div v-if="loaded && salasFiltradas.length" class="monitorar-container">
        <Box class="box" space="medium" v-for="(turma, index) in salasFiltradas" :key="index">
          <AccountMultipleOutline :size="34" class="badge" />

          <div class="box-content">
            <h2>{{ turma.sala }}</h2>

            <div v-if="turma.aula.aula" class="box-infos">
              <div>
                CFC:
                <span>{{ turma.cfc }}</span>
              </div>
              <div>
                Turma:
                <span>{{ turma.aula.aula.turma.id_agrupamento }}</span>
              </div>
              <div>
                Aula:
                <span>{{ turma.aula.aula.id_aula_teorica }}</span>
              </div>
              <div>
                Instrutor:
                <span>{{ turma.aula.aula.instrutor.nome }}</span>
              </div>
              <div>
                Materia:
                <span>{{ turma.aula.aula.materia.titulo }}</span>
              </div>
              <div>
                Aula inicia as:
                <span>{{ turma.aula.aula.inicio.split(' ')[1] }}</span>
              </div>
              <div>
                Fim previsto:
                <span>{{ turma.aula.aula.fim.split(' ')[1] }}</span>
              </div>
              <div>
                Quantidade de alunos na turma:
                <span>{{ turma.aula.aula.turma.quantidade_alunos }}</span>
              </div>
              <div>
                Presenças confirmadas:
                <span>{{ turma.aula.aula.quantidade_alunos_presentes }}</span>
              </div>
            </div>

            <div class="buttons-container">
              <Button type="button" @handle:click="paginaSala(turma)" text="Monitorar fotos" color="primary" />
            </div>
          </div>
        </Box>
      </div>

      <div v-else class="empty">
        Não há aulas virtuais no momento.
      </div>
    </template>
  </PageContainer>
</template>

<script>
import * as spinners from 'epic-spinners'
import PageContainer from '../core/PageContainer'
import Box from '../core/Box'
import Button from '../core/Button'
import AccountMultipleOutline from 'icons/AccountMultipleOutline'

import MonitoramentoController from './MonitoramentoController'

export default {
  name: "MonitorarVirtual",
  components: {
    ...spinners,
    AccountMultipleOutline,
    PageContainer,
    Box,
    Button,
  },
  data() {
    return {
      salas: [],
      aulas: [],
      loaded: false,
    }
  },
  async created() {
    MonitoramentoController.startTime()

    await this.fetchSalasVirtuais()

    this.loaded = true
  },
  computed: {
    salasFiltradas: function () {
      return this.salas.filter(function (sala) {
        if (sala.aula.length !== 0) {
          return sala
        }
      })
    },
  },
  methods: {
    async fetchSalasVirtuais() {
      await this.$http.get(`${process.env.VUE_APP_URL_API}/aulas/salas/virtual/page`)
        .then(async res => {
          res.body.dados.map(sala => {
            this.salas.push({
              id: sala.id_sala,
              sala: sala.sala,
              cfc: sala.cfc,
              aula: [],
            })
          })

          await this.showAula()
        })
    },
    async showAula() {
      const aulas = await Promise.all(
        this.salas.map(async (sala) => {
          const aula = await this.getAulaTeorica(sala)
          return { ...sala, aula }
        })
      );

      this.salas = aulas
    },
    async getAulaTeorica(sala) {
      return await this.$http.get(`${process.env.VUE_APP_URL_API}/aulas/teoricas/cfc/${sala.cfc}/sala/${sala.id}`)
        .then(res => {
          return res.body.dados
        })
        .catch(err => {
          console.log(err)
        })
    },
    paginaSala(sala) {
      this.$router.push({ name: 'ver-sala', params: { idSala: sala } })
    },
  },
}
</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  justify-content: center;

  font-size: 1rem;
  font-weight: 600;
}

.monitorar-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;

  .box {
    flex: 1;
    min-width: 34.875rem;

    display: flex;
    align-items: flex-start;
    gap: 1rem;

    .badge {
      padding: 0.8125rem;
      background: #FFF3D6;
      border: 0;
      border-radius: 23px;
      color: #FEC53D;
    }

    .box-content {
      flex: 1;
      margin-top: 0.75rem;
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      h2 {
        margin: 0;
        font-size: 1.75rem;
        font-weight: 700;
        line-height: 38.19px;
        color: #202224;
      }

      .box-infos {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        div {
          border-bottom: 1px solid #F0F0F0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;

          font-size: 1rem;
          font-weight: 600;
          line-height: 21.82px;
          color: #202224;

          span {
            text-align: right;
            font-weight: 600;
            color: #979797;
          }
        }
      }

      .buttons-container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        row-gap: 0.5rem;
        column-gap: 1.5rem;
      }
    }

    @media (max-width: 425px) {
      min-width: auto;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
  }
}
</style>
